import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { interval, Subscription } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class VersionCheckService {
    private currentVersion: string;
    private checkSubscription!: Subscription;
    private readonly CHECK_INTERVAL = 5 * 60 * 1000; // Verificar cada 5 minutos

    constructor(private http: HttpClient) {
        // Obtener la versión actual guardada o usar un valor por defecto
        this.currentVersion = localStorage.getItem('app-version') || '0.0.0';
    }

    startVersionCheck(): void {
        // Verificar inmediatamente al iniciar
        this.checkVersion();

        // Luego verificar periódicamente
        this.checkSubscription = interval(this.CHECK_INTERVAL)
            .pipe(
                switchMap(() => this.checkVersionRequest())
            )
            .subscribe({
                next: (versionData) => {
                    this.compareVersions(versionData);
                },
                error: (error) => {
                    console.error('Error al verificar versión:', error);
                }
            });
    }

    private checkVersion(): void {
        this.checkVersionRequest().subscribe({
            next: (versionData) => {
                this.compareVersions(versionData);
            },
            error: (error) => {
                console.error('Error en verificación inicial:', error);
            }
        });
    }

    private checkVersionRequest() {
        // Añadir timestamp para evitar caché del navegador
        const timestamp = new Date().getTime();
        return this.http.get<{ version: string, buildDate: string }>(
            `/assets/version.json?t=${timestamp}`
        );
    }

    private compareVersions(versionData: { version: string, buildDate: string }): void {
        if (versionData.version !== this.currentVersion) {
            console.log(`🔄 Nueva versión detectada: ${this.currentVersion} → ${versionData.version}`);
            this.handleNewVersion(versionData);
        }
    }

    private handleNewVersion(versionData: { version: string, buildDate: string }): void {
        localStorage.setItem('app-version', versionData.version);
        this.currentVersion = versionData.version;

        // Mostrar notificación no intrusiva
        const toast = document.createElement('div');
        toast.style.cssText = `
            position: fixed;
            bottom: 20px;
            right: 20px;
            background: #4CAF50;
            color: white;
            padding: 16px 24px;
            border-radius: 8px;
            box-shadow: 0 4px 12px rgba(0,0,0,0.3);
            z-index: 999999;
            font-family: sans-serif;
            animation: slideIn 0.3s ease;
        `;
                toast.innerHTML = `
            <strong>✨ Nueva versión disponible</strong><br>
            <small>Actualizando automáticamente...</small>
        `;

        document.body.appendChild(toast);

        // Recargar después de 2 segundos
        setTimeout(() => {
            window.location.reload();
        }, 2000);
    }

    stopVersionCheck(): void {
        if (this.checkSubscription) {
            this.checkSubscription.unsubscribe();
        }
    }
}